// FUNCTIONS
const animatedScroll = (element, speed = 'smooth') => {
	if (!element) {
		return;
	}

	const elementPosition = element.getBoundingClientRect().top + window.scrollY;
	const masthead = document.querySelector('#masthead');

	const offset = masthead ? masthead.offsetHeight : 0;

	window.scrollTo({
		behavior: speed,
		top: elementPosition - offset
	});
};

const checkScrollPosition = () => {
	const masthead = document.getElementById('masthead');

	if (!masthead) {
		return;
	}

	const currentScroll = window.scrollY;
	const isDesktop = window.innerWidth >= 768;
	const isHome = document.body.classList.contains('page-template-home');

	const pixelCheck = isHome ? (isDesktop ? 635 : 637) : (isDesktop ? 521 : 259);

	if (currentScroll <= pixelCheck) {
		masthead.classList.replace('opaque', 'transparent');
	} else {
		masthead.classList.replace('transparent', 'opaque');
	}
};

const fadeIn = (element, duration = 500) => {
	return new Promise((resolve) => {
		element.style.display = 'block';

		const animation = element.animate(
			[
				{
					opacity: 0
				},

				{
					opacity: 1
				}
			],

			{
				duration: duration,
				fill: 'forwards'
			}
		);

		animation.onfinish = () => {
			resolve();
		};
	});
};

const fadeOut = (element, duration = 500) => {
	return new Promise((resolve) => {
		const animation = element.animate(
			[
				{
					opacity: 1
				},

				{
					opacity: 0
				}
			],

			{
				duration: duration,
				fill: 'forwards'
			}
		);

		animation.onfinish = () => {
			element.style.display = 'none';
			resolve();
		};
	});
};

const getUrlParameter = (parameter) => {
	const variables = decodeURIComponent(window.location.search.substring(1)).split('&');
	let name;

	for (i = 0; i < variables.length; i++) {
		name = variables[i].split('=');

		if (name[0] === parameter) {
			return name[1] === undefined ? true : name[1];
		}
	}
};

const leftPad = (number, target) => {
	let output = number + '';

	while (output.length < target) {
		output = '0' + output;
	}

	return output;
};

const postRedirect = (url, data) => {
	const form = document.createElement('form');

	form.action = url;
	form.method = 'POST';
	form.style.display = 'none';
	form.target = '_self';

	// Populate payload properties dynamically
	for (const key in data) {
		if (data.hasOwnProperty(key)) {
			const input = document.createElement('input');

			input.name = key;
			input.type = 'hidden';
			input.value = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];

			form.appendChild(input);
		}
	}

	document.body.appendChild(form);

	form.submit();
	form.remove();
};

const preloadImages = async (images) => {
	const promises = images.map((src) => {
		return new Promise((resolve, reject) => {
			const img = new Image();

			img.src = src;
			img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
			img.onload = () => resolve(img);
		});
	});

	return Promise.all(promises);
};

const refreshMainMenuParameters = () => {
	const newHeight = window.innerHeight - parseInt(document.getElementById('main-menu').style.top) - 30;
	document.getElementById('main-menu').style.height = `${newHeight}px`;
};

const throttle = (func, limit = 16) => {
	let inThrottle = false;

	return (...args) => {
		if (!inThrottle) {
			func(...args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
};

// VARIABLES
const adminAjax = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/wp-admin/admin-ajax.php';
const isMastheadOpaque = document.getElementById('masthead').classList.contains('opaque');
const optimizedScrollHandler = throttle(checkScrollPosition, 50);

const allowCheckScrollPosition = [
	'page-template-about-us',
	'page-template-activities',
	'page-template-careers',
	'page-template-creative',
	'page-template-featured-shows',
	'page-template-featured-venues',
	'page-template-headliner',
	'page-template-home',
	'page-template-life-onboard',
	'page-template-live-music',
	'page-template-positions-available',
	'page-template-productions',
	'page-template-tech-recruitment',
	'page-template-upcoming-auditions',
	'single-auditions',
	'single-shows'
];

const allowOptimizedScrollHandler = [
	'page-template-about-us',
	'page-template-activities',
	'page-template-careers',
	'page-template-creative',
	'page-template-featured-shows',
	'page-template-featured-venues',
	'page-template-headliner',
	'page-template-home',
	'page-template-life-onboard',
	'page-template-live-music',
	'page-template-positions-available',
	'page-template-productions',
	'page-template-tech-recruitment',
	'page-template-upcoming-auditions',
	'single-auditions',
	'single-shows'
];

const allowSocialFeed = [
	'page-template-live-music',
	'page-template-productions',
	'page-template-tech-recruitment'
];

let paginationChangeInitialized = false;
let ticking = false;
let touchStartPosition;

// INITIALIZATION
refreshMainMenuParameters();

if (document.body.matches(allowCheckScrollPosition.map(cls => `.${cls}`).join(', '))) {
	document.addEventListener('DOMContentLoaded', checkScrollPosition());
}

if (document.body.matches(allowOptimizedScrollHandler.map(cls => `.${cls}`).join(', '))) {
	window.addEventListener('scroll', optimizedScrollHandler, { passive: true });
}

if (document.body.matches(allowSocialFeed.map(cls => `.${cls}`).join(', '))) {
	document.querySelector('.social-feed').addEventListener('click', (event) => {
		if (event.target.closest('.large, .medium, .small')) {
			const selected = event.target.closest('.large, .medium, .small');

			if (document.documentElement.classList.contains('ua-mobile') && !selected.classList.contains('active')) {
				document.querySelector('.social-feed aside.active').classList.remove('active');
				selected.classList.add('active');
			} else {
				selected.classList.remove('active');
			}
		}
	});
}

// EVENT LISTENERS
document.addEventListener('touchstart', (event) => {
	touchStartPosition = event.originalEvent.touches[0].clientY;
});

document.body.addEventListener('touchmove', (event) => {
	if (event.currentTarget.classList.contains('main-menu')) {
		event.preventDefault();
	}
});

document.getElementById('main-menu').addEventListener('click', (event) => {
	if (event.target.matches('.division h1')) {
		const division = event.target.parentElement;
		const divisionMenu = division.querySelector('ul');

		if (division.classList.contains('open')) {
			division.classList.remove('open');
			fadeOut(divisionMenu);
		} else {
			division.classList.add('open');
			fadeIn(divisionMenu);
		}
	}
});

document.getElementById('main-menu').addEventListener('touchmove', (event) => {
	if (document.body.classList.contains('main-menu')) {
		event.stopPropagation();

		const menu = document.getElementById('main-menu');
		const touchMovePosition = event.originalEvent.changedTouches[0].clientY;

		if ((menu.scrollTop == 0 && touchStartPosition < touchMovePosition) || (menu.scrollTop == (menu.scrollHeight - menu.innerHeight) && touchStartPosition > touchMovePosition)) {
			event.preventDefault();
		}
	}
});

document.querySelector('.hero .desktop nav ul li:first-of-type a')?.addEventListener('click', (event) => {
	const content = document.querySelector('.hero .desktop nav ul li:nth-of-type(1n+2)');
	const state = event.currentTarget.querySelector('i');

	if (state.classList.contains('icon-arrow-down')) {
		fadeIn(content).then(() => {
			state.classList.replace('icon-arrow-down', 'icon-arrow-up');
		});
	} else if (state.classList.contains('icon-arrow-up')) {
		fadeOut(content).then(() => {
			state.classList.replace('icon-arrow-up', 'icon-arrow-down');
		});
	}
});

document.querySelector('.hero .media-controls button')?.addEventListener('click', (event) => {
	event.preventDefault();

	const state = event.currentTarget.querySelector('i');
	const video = document.getElementById('hero-video');

	if (state.classList.contains('icon-volume')) {
		state.classList.replace('icon-volume', 'icon-muted');
	} else if (state.classList.contains('icon-muted')) {
		state.classList.replace('icon-muted', 'icon-volume');
	}

	video.muted = !video.muted;
});

document.querySelector('.hero .mobile nav ul li:first-of-type a')?.addEventListener('click', (event) => {
	var content = document.querySelector('.hero .mobile nav ul li:nth-of-type(1n+2)');
	var state = event.currentTarget.querySelector('i');

	if (state.classList.contains('icon-arrow-down')) {
		fadeIn(content);
		state.classList.replace('icon-arrow-down', 'icon-arrow-up');
	} else if (state.classList.contains('icon-arrow-up')) {
		fadeOut(content);
		state.classList.replace('icon-arrow-up', 'icon-arrow-down');
	}
});

document.querySelector('#masthead .menu > a').addEventListener('click', () => {
	const masthead = document.getElementById('masthead');

	if (document.body.classList.contains('main-menu')) {
		const currentlyOpen = document.querySelector('#main-menu .division.open');

		document.body.classList.remove('main-menu');

		if (currentlyOpen) {
			currentlyOpen.classList.remove('open');
			currentlyOpen.querySelector('ul').style.display = 'none';
		}

		if (isMastheadOpaque) {
			masthead.classList.replace('transparent', 'opaque');
		}
	} else {
		document.body.classList.add('main-menu');

		if (isMastheadOpaque) {
			masthead.classList.replace('opaque', 'transparent');
		}
	}
});

document.querySelector('#masthead .profile > a')?.addEventListener('click', (event) => {
	event.stopPropagation();

	const masthead = document.getElementById('masthead');
	const mastheadProfileSubmenu = masthead.querySelector('.profile .submenu');

	const closeMenu = (event) => {
		const profileContainer = masthead.querySelector('.profile');

		if (profileContainer && !profileContainer.contains(event.target)) {
			masthead.classList.remove('profile-open');
			fadeOut(mastheadProfileSubmenu);
		} else {
			document.addEventListener('click', closeMenu, { once: true });
		}
	};

	if (masthead.classList.contains('profile-open')) {
		masthead.classList.remove('profile-open');
		fadeOut(mastheadProfileSubmenu);
	} else {
		masthead.classList.add('profile-open');
		fadeIn(mastheadProfileSubmenu);
	}

	document.addEventListener('click', closeMenu, { once: true });
});

window.addEventListener('resize', () => {
	refreshMainMenuParameters();

	const arrowDesktop = document.querySelector('.hero .desktop nav ul li:first-of-type i');
	const arrowMobile = document.querySelector('.hero .mobile nav ul li:first-of-type i');

	if (window.innerWidth >= 1006 && arrowDesktop && arrowMobile) {
		document.querySelector('.hero .desktop nav ul li:nth-of-type(1n+2)').style.display = '';
		document.querySelector('.hero .mobile nav ul li:nth-of-type(1n+2)').style.display = '';

		if (arrowDesktop.classList.contains('icon-arrow-up')) {
			arrowDesktop.classList.replace('icon-arrow-up', 'icon-arrow-down');
		}

		if (arrowMobile.classList.contains('icon-arrow-up')) {
			arrowMobile.classList.replace('icon-arrow-up', 'icon-arrow-down');
		}
	}
});